import { render, staticRenderFns } from "./RevealV2MenuBar.vue?vue&type=template&id=19ef2919&scoped=true"
import script from "./RevealV2MenuBar.vue?vue&type=script&lang=js"
export * from "./RevealV2MenuBar.vue?vue&type=script&lang=js"
import style0 from "./RevealV2MenuBar.vue?vue&type=style&index=0&id=19ef2919&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef2919",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ef2919')) {
      api.createRecord('19ef2919', component.options)
    } else {
      api.reload('19ef2919', component.options)
    }
    module.hot.accept("./RevealV2MenuBar.vue?vue&type=template&id=19ef2919&scoped=true", function () {
      api.rerender('19ef2919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/cfdeRevealV2/RevealV2MenuBar.vue"
export default component.exports